import { QueryClientProvider } from "@tanstack/react-query";
import { type ComponentPropsWithoutRef, Suspense, lazy } from "react";
import { queryClient } from "../../query";
const GroupedInvoiceInner = lazy(() => import("./grouped-invoice"));

export default function GroupedInvoice(
  props: ComponentPropsWithoutRef<typeof GroupedInvoiceInner>
) {
  return (
    <QueryClientProvider client={queryClient}>
      <Suspense fallback={<div>Loading...</div>}>
        <GroupedInvoiceInner {...props} />
      </Suspense>
    </QueryClientProvider>
  );
}
